import {useNavigate} from '@tanstack/react-router'
import ArrowUpRightIcon from '../landing/icons/ArrowUpRightIcon'
import {type GeneratorHandoff, stashGeneratorTournament} from '../start/generatorHandoff'

// Shown under a free generator's results. Stashes the entered participants + format and sends the user
// to /start/from-generator, which signs them up (single page) and replays it into a real tournament.
export default function MakeItLiveCta({buildPayload, formatLabel}: {
    buildPayload: () => GeneratorHandoff | null;
    formatLabel: string;
}) {
    const navigate = useNavigate()
    const go = () => {
        const payload = buildPayload()
        if (!payload || !payload.teams?.length) return
        stashGeneratorTournament(payload)
        navigate({to: '/start/from-generator' as any})
    }
    return (
        <div className="mt-10 rounded-2xl border-2 border-[#082F8A]/20 bg-[#F6F7FB] p-6 lg:p-8">
            <h3 className="font-bebas text-2xl lg:text-3xl text-[#1a1a2e] font-bold tracking-wide">Make it live on ScorePal — free</h3>
            <p className="font-inter text-sm text-[#1a1a2e]/70 mt-1 max-w-2xl">
                Turn this into a real tournament with live scores, auto-updating standings, a shareable page and an embeddable widget. We'll keep your participants and this {formatLabel} format — no retyping.
            </p>
            <div className="mt-5">
                <button onClick={go}
                        className="inline-flex items-center justify-center gap-2 bg-[#082F8A] text-white rounded-full pl-6 pr-1 py-1 font-semibold hover:bg-[#06246b] transition">
                    <span className="font-inter text-base font-medium">Create my live tournament</span>
                    <div className="bg-white rounded-full p-1">
                        <ArrowUpRightIcon className="text-[#082F8A]" size={28} />
                    </div>
                </button>
            </div>
            <p className="font-inter text-xs text-[#1a1a2e]/50 mt-3">Free to start — you'll add a few details, then land straight on your live draw.</p>
        </div>
    )
}
